const StepThreeSignature = () => (
    <svg
        id="buying-online-steps--signature-svg"
        xmlns="http://www.w3.org/2000/svg"
        width="166.72"
        height="86.45"
        viewBox="0 0 166.72 86.45"
        aria-hidden="true"
        focusable="false"
    >
        <path
            id="buying-online-steps--signature-path"
            d="M62.73,59.39C77.26,54.76,78,26.35,78.6,10.76c0,0-.46,73.95-8.17,73.95S60.77,59,50.18,45.07C16.49.93-28.78,67.7,31,62.69c21-1.76,39-10.57,55-21.63,51.58-35.73,18.33-66.06.17-4.3C73.16,81,94.65,60.05,99,50.58c3.18-7,.33,21.91,12.83-.82,0,0-1.38,20.43,11.28,11.06,7.21-5.34,1.72-22.31-4-15.08-5.28,6.71,12.77,25.91,20.48,5.5,17.07-45.14-16.93-28.64-5.5,1.21,8.8,23,14.64,10.68,21.79,4.07,5.2-4.79-4.91,9.94,9.69,5.4"
            transform="translate(-0.34 0.25)"
            fill="none"
            stroke="#001333"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="3"
        />
    </svg>
);

export default StepThreeSignature;
